import { DataTable } from "@/components/composables/DataTable";
import { useGetAllTerminal } from "../misc/mutations";
import { Checkbox } from "@/components/ui/checkbox";

import { ColumnDef } from "@tanstack/react-table";
import { Badge } from "@/components/ui/badge";
import useControl from "@/hooks/useControl";

import { useState } from "react";
import moment from "moment";

import Pagination from "../misc/pagination";
import { Terminal } from "../misc/types";
import { Button } from "@/components/ui/button";
import TerminalFormModal from "../misc/addTerminalModal";
import ViewTerminalModal from "../misc/viewTerminalModal";
import TerminalOptions from "../misc/terminalOptions";
import DeleteTerminalModal from "../misc/deleteTerminalModal";
import EditTerminalModal from "../misc/editTerminalModal";
import { Filter12Filled } from "@fluentui/react-icons";

const filterFields = [
  { name: "terminalId", label: "Terminal ID", type: "text" },
  { name: "serialNumber", label: "Serial Number", type: "text" },
  { name: "approvalStatus", label: "Approval Status", type: "text" },
  { name: "supportNumber", label: "Support Number", type: "text" },
  { name: "terminalName", label: "Terminal Name", type: "text" },
  { name: "customerType", label: "Customer Type", type: "text" },
  { name: "status", label: "Status", type: "text" },
  { name: "merchantName", label: "Merchant Name", type: "text" },
];

const TerminalPage = () => {
  const {
    state: isOpenView,
    setTrue: onOpenView,
    setFalse: onCloseView,
  } = useControl();
  const {
    state: isOpenViewModal,
    setTrue: onOpenViewModal,
    setFalse: onCloseViewModal,
  } = useControl();
  const {
    state: isOpenDeleteModal,
    setTrue: onOpenDeleteModal,
    setFalse: onCloseDeleteModal,
  } = useControl();
  const {
    state: isOpenEditModal,
    setTrue: onOpenEditModal,
    setFalse: onCloseEditModal,
  } = useControl();

  const [currentPage, setCurrentPage] = useState(1);
  const [filters, setFilters] = useState<any>({});
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const handleFilterChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    setFilters((prev: any) => ({ ...prev, [e.target.name]: e.target.value }));
  };
  const handleSidebarClose = () => setSidebarOpen(false);
  const handleSidebarOpen = () => setSidebarOpen(true);

  const { data, isPending } = useGetAllTerminal({
    size: 10,
    page: currentPage,
    ...filters,
  });


  const [, setTransactionId] = useState("");
  const [terminal, setTerminal] = useState<any>();

  const handlePageChange = (page: number) => {
    if (page > 0 && page <= (data?.paginationInfo.totalPages ?? 1)) {
      setCurrentPage(page);
    }
  };

  const columns: ColumnDef<Terminal>[] = [
    {
      id: "select",
      header: ({ table }) => (
        <Checkbox
          className="border-[#86929E]"
          checked={
            table.getIsAllPageRowsSelected() ||
            (table.getIsSomePageRowsSelected() && "indeterminate")
          }
          onCheckedChange={(value) => table.toggleAllPageRowsSelected(!!value)}
          aria-label="Select all"
        />
      ),
      cell: ({ row }) => (
        <Checkbox
          className="border-[#86929E]"
          checked={row.getIsSelected()}
          onCheckedChange={(value) => row.toggleSelected(!!value)}
          aria-label="Select row"
        />
      ),
      enableSorting: false,
      enableHiding: false,
    },
    {
      accessorKey: "terminalId",
      header: "Terminal ID",
      cell: ({ row }) => <div>{row.original.terminalId}</div>,
    },
    {
      accessorKey: "terminalName",
      header: "Terminal Name",
      cell: ({ row }) => <div>{row.original.terminalName}</div>,
    },
    {
      accessorKey: "serialNumber",
      header: "Serial Number",
      cell: ({ row }) => <div>{row.original.serialNumber}</div>,
    },
    {
      accessorKey: "terminalModel",
      header: "Terminal Model",
      cell: ({ row }) => <div>{row.original.terminalModel}</div>,
    },
    {
      accessorKey: "merchantId",
      header: "Merchant ID",
      cell: ({ row }) => <div>{row.original.merchantId}</div>,
    },
    {
      accessorKey: "terminalAddress",
      header: "Terminal Address",
      cell: ({ row }) => <div>{row.original.terminalAddress || "N/A"}</div>,
    },
    {
      accessorKey: "approvalStatus",
      header: "Approval Status",
      cell: ({ row }) => <div>{row.original.approvalStatus || "N/A"}</div>,
    },
    {
      accessorKey: "isEnabled",
      header: "Status",
      cell: ({ row }) => (
        <Badge status={row.original.isEnabled ? "Active" : "Inactive"} />
      ),
    },
    {
      accessorKey: "customerType",
      header: "Customer Type",
      cell: ({ row }) => <div>{row.original.customerType}</div>,
    },
    {
      accessorKey: "transactionLimit",
      header: "Transaction Limit",
      cell: ({ row }) => <div>{row.original.transactionLimit}</div>,
    },
    {
      accessorKey: "maximumAmount",
      header: "Maximum Amount",
      cell: ({ row }) => (
        <div>₦{row.original.maximumAmount.toLocaleString()}</div>
      ),
    },
    {
      accessorKey: "createdAt",
      header: "Created At",
      cell: ({ row }) => (
        <div>{moment(row.original.createdAt).format("LLLL")}</div>
      ),
    },
    {
      id: "actions",
      cell: ({ row }) => (
        <TerminalOptions
          setTransactionId={setTransactionId}
          setTerminal={() => setTerminal(row.original)}
          id={row.original._id}
          onOpenView={onOpenViewModal}
          onOpenDelete={onOpenDeleteModal}
          onOpenEdit={onOpenEditModal}
        />
      ),
    },
  ];

  return (
    <div>
      {/* Filter and Export Buttons */}
      <div className="flex justify-between items-center mb-4">
        <button
          className="px-4 flex items-center gap-2 py-2 bg-primary-500 text-white rounded hover:bg-primary-600"
          onClick={handleSidebarOpen}
        >
          <Filter12Filled className="text-2xl" />
          Filters
        </button>

        <div className="flex justify-end ">
          <Button
            className="bg-primary-500"
            onClick={onOpenView}>Create Terminal</Button>
        </div>
      </div>
      {/* RHS Sidebar */}
      <div
        className={`fixed top-0 right-0 h-full w-80 bg-white shadow-lg z-50 transform transition-transform duration-300 ease-in-out
          ${sidebarOpen ? "translate-x-0" : "translate-x-full"}`}
        style={{ maxWidth: 360 }}
      >
        <div className="flex justify-between items-center p-4 border-b">
          <h2 className="text-lg font-semibold">Filter Terminals</h2>
          <button
            className="text-gray-500 hover:text-gray-700 text-2xl font-bold"
            onClick={handleSidebarClose}
            aria-label="Close sidebar"
          >
            &times;
          </button>
        </div>
        <div className="p-4 overflow-y-auto" style={{ maxHeight: 'calc(100vh - 64px)' }}>
          <form className="space-y-3">
            {filterFields.map((field) => (
              <div key={field.name}>
                <label className="block text-sm font-medium mb-1" htmlFor={field.name}>
                  {field.label}
                </label>
                <input
                  id={field.name}
                  name={field.name}
                  type={field.type}
                  value={filters[field.name] || ""}
                  onChange={handleFilterChange}
                  className="border rounded px-2 py-1 w-full"
                />
              </div>
            ))}
          </form>
          <button
            type="button"
            className="mt-6 w-full bg-gray-200 hover:bg-gray-300 text-gray-800 font-semibold py-2 px-4 rounded"
            onClick={() => { setFilters({}); setSidebarOpen(false); }}
          >
            Reset
          </button>
        </div>
      </div>
      {/* Overlay */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-30 z-40"
          onClick={handleSidebarClose}
        />
      )}

      <DataTable
        isLoading={isPending}
        columns={columns}
        data={(data?.items ?? []) as Terminal[]}
      />
      <div className="flex justify-end">
        <Pagination
          currentPage={data?.paginationInfo.page ?? 1}
          totalPages={data?.paginationInfo.totalPages ?? 1}
          onPageChange={handlePageChange}
        />
      </div>

      {isOpenView && (
        <TerminalFormModal onClose={onCloseView} isOpen={isOpenView} />
      )}
      {isOpenViewModal && (
        <ViewTerminalModal
          onClose={onCloseViewModal}
          terminal={terminal as Terminal}
        />
      )}
      {isOpenDeleteModal && (
        <DeleteTerminalModal
          terminal={terminal}
          onCancel={onCloseDeleteModal}
        />
      )}
      {isOpenEditModal && (
        <EditTerminalModal
          terminal={terminal as Terminal}
          onCancel={onCloseEditModal}
          isOpenEdit={isOpenEditModal}
        />
      )}
    </div>
  );
};

export default TerminalPage;
